import { JobApiService } from 'jobs/JobApiService';
import { JobCategory } from 'jobs/types';
import { action, computed, makeObservable, observable, runInAction, toJS } from 'mobx';
import { MultiSelectViewModel } from 'shared/components';
import { v4 as uuidv4 } from 'uuid';

export class JobCategoryGroupModel {
   id = uuidv4();
   readonly multiselect: MultiSelectViewModel<JobCategory>;
   readonly subCategories = observable.array<JobCategory>([]);

   search: string = '';
   category = '';
   hidden: boolean = false;

   constructor() {
      makeObservable(this, {
         category: observable,
         hidden: observable,
         search: observable,
         onCategoryChange: action,
         show: action.bound,
         hide: action.bound,
         restore: action.bound,
         results: computed,
         value: computed,
      });

      this.multiselect = new MultiSelectViewModel<JobCategory>([], {
         maxSelected: 2,
         getLabel: (value) => {
            return value.name;
         },
      });
   }

   get value() {
      return {
         cat: this.category,
         subCat: this.multiselect.values.map((sc) => sc.id),
      };
   }

   setSubCategoryValue(values: JobCategory[]): void {
      this.multiselect.values.replace(values);
   }

   onCategoryChange(cat: string) {
      this.category = cat;
      this.getSubCategories(cat);
   }

   restore(catIds: Array<number>, subCategories: JobCategory[]): void {
      const values = subCategories.filter((sc) => catIds.includes(sc.id));
      this.multiselect.values.replace(values);
   }

   show(): void {
      this.hidden = false;
   }

   hide(): void {
      this.hidden = true;
      this.category = '';
      this.multiselect.clear();
   }

   get results(): JobCategory[] {
      return this.subCategories.filter((cat) =>
         cat.name.toLocaleLowerCase().includes(this.multiselect.search.toLocaleLowerCase())
      );
   }

   private getSubCategories = async (category: string): Promise<void> => {
      try {
         const resp = await JobApiService.getSubCategories(Number(category));
         if (resp.status === 200) {
            runInAction(() => {
               this.subCategories.replace(resp.response);
            });
         }
      } catch (e) {
         runInAction(() => {
            console.error('JobCategories: ' + e);
         });
      }
   };
}
